export default "__VITE_ASSET__7cca4d75__"